import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.606 10.711L5.75 7.856m0 0L8.606 5M5.75 7.856l7.308.002a5.192 5.192 0 010 10.384H6.135"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.713 10.46L4 6.748m0 0l3.713-3.713M4 6.748l9.5.002a6.75 6.75 0 010 13.5h-9"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.465 21.022L8.1 13.637m0 0l7.365-7.387M8.1 13.637l18.845.004c7.395 0 13.39 6.013 13.39 13.43 0 7.416-5.995 13.429-13.39 13.429H9.09"
  }))
};
export var Undo = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});